<template>
  <el-drawer :title="drawerTitle"
             :visible.sync="tempdrawer"
             :direction="direction"
             :with-header="true"
             :size="drawerSize"
             :destroy-on-close="false"
             @opened="drawerOpen"
             @close="handleClose">
    <el-menu :default-active="menukey" class="el-menu-demo" mode="horizontal" active-text-color="#409EFF"
             menu-trigger="click" @select="handleSelect">
      <el-menu-item v-for="(item) in firstmenuarrs" :key="item.menukey" :index="item.menukey">{{ item.name }}
      </el-menu-item>
      <el-submenu index="more" v-if="menukeyArray.length > showNum">
        <template slot="title">更多</template>
        <el-menu-item v-for="(item) in secondmenuarrs" :key="item.menukey" :index="item.menukey">{{ item.name }}
        </el-menu-item>
      </el-submenu>
    </el-menu>
    <div style="height:calc(100% - 65px);">
      <keep-alive>
        <component :is="menukey" :commonObject="tempobj" :commonName="objtype" :initData="initData"></component>
      </keep-alive>
    </div>
  </el-drawer>
</template>

<script>
import { regionData } from 'element-china-area-data';
import elDragDialog from '@/directive/el-dragDialog';

// import { stringify } from 'querystring'

export default {
  name: 'drawerview',
  components: {
    SelectType: () => import('@/components/SelectType'),
    usersview: () => import('@/views/usermanager/ShowView'), // 用户视图
    accinfosview: () => import('@/views/accinfos/ShowView'), // 账套视图
    dbconnectionsview: () => import('@/views/dbconnections/ShowView'), // 数据库连接视图
    basemessagesview: () => import('@/views/basemessages/ShowView'), // 消息通知提醒视图
    computationunitsview: () => import('@/views/computationunits/ShowView'), // 视图
    inventoryclasssview: () => import('@/views/inventoryclasss/ShowView'), // 视图
    inventorysview: () => import('@/views/inventorys/ShowView'), // 视图
    tx_supplyinfosview: () => import('@/views/tx_supplyinfos/ShowView'), // 视图
    tx_veninfosview: () => import('@/views/tx_veninfos/ShowView'), // 视图
    tx_purchaseplansview: () => import('@/views/tx_purchaseplans/ShowView'), // 视图
    tx_orderplan_detailsview: () => import('@/views/tx_orderplan_details/ShowView'), // 视图
    tx_quotsview: () => import('@/views/tx_quots/ShowView'), // 视图
    tx_compareformsview: () => import('@/views/tx_compareforms/ShowView'), // 视图
    invordersview: () => import('@/views/invorders/ShowView'), // 视图
    tx_quot_supplysview: () => import('@/views/tx_quot_supplys/ShowView'), // 视图
    tx_orderplansview: () => import('@/views/tx_orderplans/ShowView'), // 视图
    tx_venclasssview: () => import('@/views/tx_venclasss/ShowView'), // 视图
    tx_quot_finishdatesview: () => import('@/views/tx_quots/ShowView') // 视图
  },
  directives: { elDragDialog },
  props: {
    drawer: {
      type: Boolean,
      default: false
    },
    tempobj: {
      type: Object,
      default() {
        return {
          id: '',
          name: ''
        };
      },
      required: false
    },
    objtype: {
      type: String,
      required: true
    },
    menukeyArray: {
      type: Array,
      required: true
    },
    drawerTitle: {
      type: String,
      default: '详细列表'
    },
    drawerSize: {
      type: String,
      default: '70%'
    },
    showNum: {
      type: Number,
      default: 10
    },
    defaultProps: {
      type: Object,
      default() {
        return {
          name: 'name',
          value: 'menukey'
        };
      }
    },
    initData: {
      type: Object
    }
  },
  computed: {
    firstmenuarrs() {
      if (this.menukeyArray.length > this.showNum) {
        return this.menukeyArray.slice(0, this.showNum);
      } else {
        return this.menukeyArray;
      }
    },
    secondmenuarrs() {
      var menulength = this.menukeyArray.length;
      if (menulength > this.showNum) {
        return this.menukeyArray.slice(this.showNum, menulength);
      } else {
        return [];
      }
    }
  },
  mounted() {
    this.tempdrawer = this.drawer;
    // this.menukey = this.menukeyArray[0][this.defaultProps.value]
  },
  data() {
    return {
      menukey: '',
      tempdrawer: false,
      modal: true,
      activeName: 'first',
      regionOptions: regionData,
      direction: 'rtl', // 弹出方式
      // defaultMenuKey: '',
      listQuery: { // 查询条件
        id: '',
        name: ''
      }
    };
  },
  watch: {
    drawer(val) {
      this.tempdrawer = val;
    }
  },
  methods: {
    drawerOpen() {
      setTimeout(() => { // 设置延迟执行
        this.menukey = this.menukeyArray[0][this.defaultProps.value];
      }, 100);
    },
    handleSelect(key, keyPath) {
      this.menukey = key;
      // console.log(key, keyPath)
    },
    handleClose() {
      this.menukey = '';
      // this.defaultMenuKey = this.menukeyArray[0][this.defaultProps.value]
      this.$emit('update:drawer', false);
    }
  }
};
</script>

<style scoped>
.bg-purple {
  background: #f5f7fa;
}

.grid-content {
  border-radius: 4px;
  min-height: 36px;
}

.el-select {
  display: block;
}
</style>
